import React, { useState } from "react";
import "./navbar.scss";
import logo from "./Logo.svg";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

const Navbar = () => {

  const navigate = useNavigate();

  const [addActive, setAddActive] = useState(false);
  const handleClick = (e) => {
    setAddActive(!addActive);
    console.log(addActive);
  };
  return (
    <div className="Navbar">
      <div className="navbar-logo">
        <img src={logo} alt="" />
        <h2>FreshPage</h2>
      </div>

      <ul className={`nav-links-ul ${addActive === true && "active"}`} >
        <li className="nav-link"  >
          <Link
          onClick={() => navigate("/")}

            smooth={true}
            duration={500}
            style={{ cursor: "pointer" }}
            to="hero"
          >
            Home
          </Link>
        </li>
        <li className="nav-link">
          <Link
            smooth={true}
            duration={500}
            style={{ cursor: "pointer" }}
            to="feature"
          >
            Features
          </Link>
        </li>
        <li className="nav-link">
          <Link
            smooth={true}
            duration={500}
            style={{ cursor: "pointer" }}
            to="pricing"
          >
            Pricing
          </Link>
        </li>
        <li className="nav-link" >
          <Link
            smooth={true}
            duration={500}
            style={{ cursor: "pointer" }}
            to="demo"
          >
            Demo
          </Link>
        </li>
        <li className="nav-link">
          <Link
            onClick={() => navigate("/contactUs")}
            smooth={true}
            duration={500}
            style={{ cursor: "pointer" }}
            to="/contactUs"
          >
            Contact Us
          </Link>
        </li>

        <li className="nav-button">
          <Link
            smooth={true}
            duration={500}
            style={{ cursor: "pointer" }}
            to="login"
          >
            Login
          </Link>
        </li>
        <li className="nav-button try-now-button">
          <Link
          onClick={()=>window.location.replace('https://play.google.com/store/apps/details?id=in.freshpage.android')}
            smooth={true}
            duration={500}
            style={{ cursor: "pointer" }}
            to="TryNow"
          >
            Try Now
          </Link>
        </li>
      </ul>

      <div
        onClick={handleClick}
        className={`hamburger ${addActive === true && "active"}`}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </div>
  );
};

export default Navbar;
